import { render, staticRenderFns } from "./tableAnswered.vue?vue&type=template&id=32742afc&scoped=true"
import script from "./tableAnswered.vue?vue&type=script&lang=js"
export * from "./tableAnswered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32742afc",
  null
  
)

export default component.exports